import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthRequest, LoginRequest } from '../../models/login-request';
import { OtpRequest } from '../../models/otp-request';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public defaultHeaders = new HttpHeaders();

  constructor(
    private http: HttpClient
    , private cookie: CookieService
  ) { }

  logout() {
    return this.http.get<any>(`${environment.baseUrl}${environment.auth.logout}`);
  }

  loginldap(authRequest: AuthRequest): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}${environment.auth.login}`, authRequest);
  }

  login(request: LoginRequest) {
    const authType = "JWT";
    const headers = request ? new HttpHeaders({
      'Authorization': 'Basic ' + btoa(request.username + ':' + request.password),
      'authType': authType
    }) : new HttpHeaders();
    return this.http.post<any>(`${environment.baseUrl}${environment.auth.login}`, {}, { headers: headers });
  }



  sendOtp(url, request: OtpRequest): any {
    return this.http.post(url, request);
  }

  resendOtp(url, request: OtpRequest): any {
    return this.http.post(url, request);
  }

  verifyOtp(url, request: OtpRequest): any {
    return this.http.post(url, request);
  }

  oauth() {
    return this.http.get(`${environment.baseUrl}${environment.auth.oauth}`);
  }

  refreshToken(token: string) {
    return this.http.get(`${environment.baseUrl}${environment.auth.refreshToken}?refreshToken=${token}`, {
      headers: { skipAuthHeaders: 'true' }
    });
  }

  isLoggedIn(): boolean {
    if (this.cookie.get('accessToken')) {
      return true;
    }
    return false;
  }
}
